import { useRouter } from 'expo-router';
import { useState } from 'react';

import { PaywallSheet } from '@/components/domain/PaywallSheet';
import { PLANS, TRIAL_LINE, useEntitlement } from '@/lib/billing';

export default function PaywallScreen() {
  const router = useRouter();
  const { purchase, restore } = useEntitlement();
  const [selected, setSelected] = useState(PLANS[0]?.id ?? 'annual');
  const [busy, setBusy] = useState(false);

  function close() {
    if (router.canGoBack()) router.back();
    else router.replace('/');
  }

  async function run(action: () => Promise<void>) {
    setBusy(true);
    try {
      await action();
      close();
    } catch (e) {
      // BillingUnavailableError until RevenueCat is wired (see lib/billing).
      alert((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <PaywallSheet
      visible
      onClose={close}
      plans={PLANS}
      selectedPlanId={selected}
      onSelectPlan={setSelected}
      trialLine={TRIAL_LINE}
      busy={busy}
      onSubscribe={() => run(() => purchase(selected))}
      onRestore={() => run(() => restore())}
    />
  );
}
